export default "__VITE_ASSET__B0xgD7LO__"